export default "__VITE_ASSET__DEReXd1W__"